import * as React from 'react';
import { classNames } from '@/utils';

export interface ButtonIconProps {
  /** The child elements to be rendered inside the button (required). */
  children: React.ReactNode;
  /**
   * - 'close': use to close alert
   * - 'close-tag': use to close tag component
   * - 'close-modal': use to close modal
   */
  variant?: 'close' | 'close-tag' | 'close-modal';
  /** Whether the button should be disabled (optional). */
  disabled?: boolean;
  /** Whether the button should submit a form (optional). */
  submit?: boolean;
  /** A function to be called when the button is clicked (optional). */
  onClick?(): void;
  /** CSS class names to be applied to the button element (optional). */
  className?: string;
  /** Inline styles to be applied to the button element (optional). */
  style?: React.CSSProperties;
  /** Whether the button should render as an icon button (optional). */
}

export const ButtonIcon = React.forwardRef<HTMLButtonElement, ButtonIconProps>((props, ref) => {
  const { children, submit, variant = 'close', disabled, className, style, onClick } = props;

  return (
    <button
      ref={ref}
      style={style}
      onClick={onClick}
      disabled={disabled}
      type={submit ? 'submit' : 'button'}
      className={classNames('button-icon', variant, { disabled }, className)}
    >
      {children}
    </button>
  );
});

ButtonIcon.displayName = 'ButtonIcon';
